import { Box, Button, IconButton, Tooltip, Autocomplete, TextField, Typography, FormControl, InputLabel, Select, MenuItem } from "@mui/material"
import { DataGrid } from "@mui/x-data-grid"
import React, { Component } from "react"
import { ImagePaths } from "../../../../Utility/ImagePaths"
import CommonGridHeader, { CommonPatientDetails } from "../../../../Components/Common Components/CommonComponents"
import { Colors } from "../../../../Styles/Colors"
import { Trans, withTranslation } from 'react-i18next'
import { t } from 'i18next'
import RestAPIService from "../../../../Utility/Services/RestAPIService"
import { Serviceurls } from "../../../../Utility/API/Serviceurls"
import ToastMsg from "../../../../Components/ToastMsg/ToastMsg"
import Loader from '../../../../Components/Loader';
import CommonDatePicker from '../../../../Components/Common Components/CommonDatePicker'
import { getCachevalue, localGetItem } from "../../../../Utility/Services/CacheProviderService"
import PrintPreviewPop from "../../../../Components/Common Components/PrintPreviewPop"
import { CheckAccessFunc } from "../../../../Components/CommonFunctions/CommonFunctions"

class SurgeryReport extends Component {
    constructor(props) {
        super(props)
        this.state = {
            surgeryData: [],
            page: 0,
            pageSize: 10,
            loading: false,
            isErrorMsg: false,
            successMsg: false,
            isErrorMsgText: '',
            successMsgText: '',
            patientDetails: {},
            patientId: '',
            clinicId: '',
            appointmentId: '',
            loading: false,
            startDate: '',
            endDate: '',
            dateIndex: 0,
            selectedDoctor: "All",
            admissionId: null,
            patientData: {},
            withOutAppointment: {},
            userAccess : false,
            surID : null,
        }
    }

    componentDidMount() {
        let userInfo =   JSON.parse(localGetItem('loggedInUserInfo')) 
        let docClinicId =   getCachevalue('SelectedDoctorClinic')
        let clinicId = userInfo.clinic_id ? userInfo.clinic_id  : docClinicId
        let patientData = this.props.fromIP ? JSON.parse(getCachevalue('IppatientData')) : JSON.parse(getCachevalue('patientData'))
        let appointmentId = this.props.fromOT ? JSON.parse(getCachevalue("OTpatientData")) : JSON.parse(getCachevalue('DoctorPatientData'))
        let userAccess = CheckAccessFunc("front_office", "Home", "Surgery Reports", null, "Tab")?.editAccess 
                this.setState({
            clinicId: clinicId ? clinicId : null,
            appointmentId: appointmentId?.appointment_id,
            patientId: appointmentId?.patient_id,
            patientData: patientData,
            patientDetails: patientData || appointmentId,
            userAccess: userAccess,
        }, () => {
            if (!this.props.fromIP && !this.props.fromOP) {
            this.getPatientDetailData()
            }
            this.getSummaryData()
            this.getDoctorListData()
        })
    }

    getPatientDetailData = () => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_PATIENT_DETAIL_GET + '?patient_id=' + (this.state.patientData?.patient_id ?  this.state.patientData?.patient_id  : this.state.patientId))
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.setState({
                            patientDetails: {...this.state.patientDetails, ...response?.data?.data}
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error?.response?.data?.message)
                    } else {
                        this.errorMessage(error?.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error?.message)
        }
    }

    getSummaryData = () => {
        try {
            this.setState({loading: true})
            let selectedDoc = this.state.selectedDoctor ? this.state.selectedDoctor === 'All' ? "" : this.state.selectedDoctor?.doctor_id : ''
            RestAPIService.getAll(Serviceurls.FO_SURGERY_REPORT + `?patient_id=${this.state.patientData?.patient_id ? this.state.patientData?.patient_id  : this.state.patientId}&doctor_id=${selectedDoc}&from_date=${this.state.startDate}&to_date=${this.state.endDate}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.setState({
                            surgeryData: response?.data?.data
                        },()=>{this.setState({loading: false})})
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error?.response?.data?.message)
                    } else {
                        this.errorMessage(error?.message)
                    }
                    this.setState({loading: false})
                })
        } catch (error) {
            this.errorMessage(error.message)
            this.setState({loading: false})
        }
    }

    getDoctorListData = () => {
        try{
            RestAPIService.getAll(Serviceurls.DOC_DOCTOR_CLINIC_LIST_GET + `?clinic_id=${this.state.clinicId ? this.state.clinicId : null}` )
            .then((response)=>{
                if(response?.data?.status === 'success'){
                    this.setState({docDetails: response?.data?.data})
                }
            }).catch((error)=>{
                if (error?.response?.data?.message) {
                    this.errorMessage(error?.response?.data?.message)
                } else {
                    this.errorMessage(error?.message)
                }
            })

        }catch(e){
            this.errorMessage(e?.message)
        }
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    filterDate = (From, To, Index) => {
        this.setState({
            startDate: From,
            endDate: To,
            dateIndex: Index
        })
    }

    onClearDisSumFilter = () => {
        try {
            this.setState({
                startDate: '',
                endDate: '',
                dateIndex: 0,
                selectedDoctor: "All"
            },()=>{
                this.getSummaryData()
            })
        } catch (error) {
            this.errorMessage(error?.message)
        }
    }

    ClosePopUp = () => {
        this.setState({ printPreview: false })
    }

    renderLeftSide = () => {
        try {
            const { t } = this.props
            this.state.surgeryData?.forEach((element, index) => element.sno = index + 1)
            const columns = [
                {
                    field: 'surgery_date', headerName: t("Surgery Date"), flex: 0.333, headerAlign: 'center', align: "center",
                    renderCell: (params) => (<Box>{params?.row?.surgery_date ? params?.row?.surgery_date : '-'}</Box>)
                },
                {
                    field: 'doctor_name', headerName: t("Doctor Name"), flex: 0.333, headerAlign: 'center', align: "center",
                    renderCell: (params) => (<Box>{params?.row?.doctor_name ? params?.row?.doctor_name.length > 15 ? <Tooltip placement="top" title={params?.row?.doctor_name}><div>{params?.row?.doctor_name.slice(0,15) + '...'}</div></Tooltip> : params?.row?.doctor_name : '-'}</Box>)
                },
                {
                    field: 'action', headerName: t("Action"), flex: 0.333, headerAlign: 'center', align: "center",
                    renderCell: (params) => (<Box>
                        {params?.row?.is_finish ? <IconButton emed_tid={`surgery_report_print_btn_${params.row.sno}`}><Tooltip placement='top' title='Print' arrow><div><img className='eMed_upload' src={!this.state.userAccess ? ImagePaths.ViewButtonOff.default : ImagePaths.LabViewButton.default} disabled={!this.state.userAccess} onClick={() => this.setState({ printPreview: true, admissionId: params?.row?.ip_admission_id, surID: params?.row?.id })} alt='print' /></div></Tooltip></IconButton> : "In Progress"}</Box>)
                }
            ]
            return (
                <DataGrid
                    rows={this.state.surgeryData}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    page={this.state.page}
                    pageSize={this.state.pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    sx={{ backgroundColor: Colors.white }}
                    components={{
                        Toolbar: CommonGridHeader.CommonToolBar,
                        NoRowsOverlay: () => (
                            <Box className='eMed_conf_nodata'>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                    onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    disableSelectionOnClick
                    loading={this.state.loading}
                />
            )
        } catch (error) {
            this.errorMessage(error?.message)
        }
    }

    renderRightSide = () => {
        try {
            return (
                <Box>
                    <Box component={'div'} height={'2.5vw'} display={'flex'} pl={'0.5vw'} alignItems={'center'}>
                        <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>Filter</Typography>
                    </Box>
                    <Box component={'div'} height={'23vw'} sx={{ background: Colors.white }} p={'1vw'} display={'flex'} width={'100%'}>
                        <Box component={'div'} width={'45%'} marginTop={'1vw'}>
                            <CommonDatePicker
                                FromDate={this.state.startDate}
                                ToDate={this.state.endDate}
                                DateIndex={this.state.dateIndex}
                                SelectedDates={this.filterDate.bind(this)}
                                Future ={true}
                            />
                        </Box>
                        <Box component={'div'} width={'45%'}>
                        <FormControl size='small' className='eMed_small_textFields'>
                            <InputLabel>{"Select Doctor"}</InputLabel>
                            <Select
                            value={this.state.selectedDoctor ? this.state.selectedDoctor : ""}
                            label={"Select Doctor"}
                            onChange={(e) => { this.setState({ selectedDoctor: e.target.value }) }}
                            MenuProps={{
                                style: { maxWidth:'15vw',maxHeight: 350 }
                            }}
                            emed_tid="surgery_report_doctor_select"
                            >
                            <MenuItem value={"All"} emed_tid="surgery_report_doctor_all_item">{"All"}</MenuItem>
                            {
                                this.state.docDetails?.length > 0 ?
                                this.state.docDetails.map((list, index) => (
                                    <MenuItem key={index} value={list} emed_tid={`surgery_report_doctor_item_${index}`}>{`${(list?.title ? list?.title : "")} ${list?.first_name} ${(list?.initial ? list?.initial : "")}`}</MenuItem>
                                )) : null
                            }
                            </Select>
                        </FormControl>
                        </Box>
                    </Box>
                    <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'} height={'3vw'}>
                        <Button
                            sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize', mr: '1vw' }}
                            variant='outlined'
                            disabled = {!this.state.userAccess}
                            onClick={() => this.onClearDisSumFilter()}
                            emed_tid="surgery_report_clear_btn"
                        >Clear</Button>
                        <Button
                            sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize' }}
                            variant='contained'
                            disabled = {!this.state.userAccess}
                            onClick={() => this.getSummaryData()}
                            emed_tid="surgery_report_search_btn"
                        >Search</Button>
                    </Box>
                </Box>
            )
        } catch (error) {
            this.errorMessage(error?.message)
        }
    }

    render() {
        return (
            <Box component={'div'} sx={{ backgroundColor: Colors.Background }} height={'74vh'} p={'0.5vw'}>
                <Box component={'div'} display={'flex'}>
                    <Box component={'div'} className='doc_header_card' mr={'0.5vw'}>
                        <CommonPatientDetails data={this.state.patientDetails} showDetailed={true} fromDoctor={true} />
                    </Box>
                </Box>
                <Box component={'div'} display={'flex'} mt={'0.5vw'} height={'61.5vh'}>
                    <Box component={'div'} flex={0.65} overflow={'scroll'}>
                        {this.renderLeftSide()}
                    </Box>
                    <Box component={'div'} flex={0.35} border={'1px solid lightgray'}>
                        {this.renderRightSide()}
                    </Box>
                </Box>
                {this.state.printPreview ?
                    <PrintPreviewPop
                        PRINT_URL={Serviceurls.SUR_NOTE_PRINT + `?ip_admission_id=${this.state.admissionId}&surgery_notes_id=${this.state.surID}&clinic_id=${this.state.clinicId? this.state.clinicId : null }&export=pdf`}
                        Title={t("Surgery Notes")}
                        BillData={this.state.selectedRow}
                        ClosePopUp={this.ClosePopUp.bind(this)}
                        PrintButton={false}
                        history={this.props.history}
                    />
                    : null}
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                <Loader loaderOpen={this.state.isLoader} />
            </Box>
        )
    }
}
export default withTranslation()(SurgeryReport)

